/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './Providers';
import { Routes } from './Routes';
import reportWebVitals from './reportWebVitals';

createRoot(document.getElementById('root')!).render(
    <Providers>
      <Routes />
    </Providers>
);

reportWebVitals();
